"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var IntlService_1 = require("../Intl/IntlService");
var LocalizationService_1 = require("../Localization/LocalizationService");
/** @hidden */
exports.GlobalizationContext = React.createContext({
    intl: new IntlService_1.IntlService('en'),
    localization: new LocalizationService_1.LocalizationService()
});
//# sourceMappingURL=GlobalizationContext.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-intl/dist/npm/globalization/GlobalizationContext.js
// module id = 97
// module chunks = 0